/* VNSTRA montagevideo - laadt de YouTube-speler pas na een klik. Geen library. */
(function () {
  function init(root) {
    var id = root.getAttribute('data-vnstra-video');
    var btn = root.querySelector('.vnstra-video__btn');
    var dlg = root.querySelector('dialog.vnstra-dialog');
    var frame = root.querySelector('.vnstra-dialog__frame');
    var closeBtn = root.querySelector('.vnstra-dialog__close');
    if (!id || !btn || !dlg || !frame) return;
    var warmed = false;
    function warm() {
      if (warmed) return;
      warmed = true;
      var l = document.createElement('link');
      l.rel = 'preconnect';
      l.href = 'https://www.youtube-nocookie.com';
      document.head.appendChild(l);
    }
    btn.addEventListener('mouseenter', warm);
    btn.addEventListener('touchstart', warm, { passive: true });
    btn.addEventListener('click', function () {
      var src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&cc_load_policy=1';
      var f = document.createElement('iframe');
      f.setAttribute('src', src);
      f.setAttribute('title', btn.getAttribute('aria-label') || 'Video');
      f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      f.setAttribute('allowfullscreen', '');
      frame.appendChild(f);
      if (typeof dlg.showModal === 'function') { dlg.showModal(); } else { dlg.setAttribute('open', ''); }
    });
    dlg.addEventListener('close', function () {
      frame.innerHTML = '';
      btn.focus();
    });
    if (closeBtn) closeBtn.addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) {
      var r = dlg.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dlg.close();
    });
  }
  function boot() {
    var nodes = document.querySelectorAll('[data-vnstra-video]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
